// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__Xo7Yc","breadcrumbsStyles":"styles_breadcrumbsStyles__mutPG"};